// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"buttonStyles_buttonWrapper__2Vp7a","button":"buttonStyles_button__2Mmz_","active":"buttonStyles_active__6kK-z","Separator":"buttonStyles_Separator__2UNoB"};